import React, { createContext, useContext, useState, ReactNode } from "react";
import { $champagne7, $beigeBg } from "../../Utils/color";

// Define the context type for the quantifier button styles
interface QuantifierContextType {
  // Default background colors for different states
  buttonBackgroundColor?: string;
  mobileButtonBackgroundColor?: string;
  darkModeButtonBackgroundColor?: string;

  // Methods to update the colors
  setButtonBackgroundColor: (color: string) => void;
  setMobileButtonBackgroundColor: (color: string) => void;
  setDarkModeButtonBackgroundColor: (color: string) => void;

  // Reset to default colors
  resetColors: () => void;
}

// Create the context with default values
export const QuantifierContext = createContext<QuantifierContextType>({
  // buttonBackgroundColor: $champagne7,
  // mobileButtonBackgroundColor: $beigeBg,
  // darkModeButtonBackgroundColor: "#494949",

  setButtonBackgroundColor: () => {},
  setMobileButtonBackgroundColor: () => {},
  setDarkModeButtonBackgroundColor: () => {},

  resetColors: () => {},
});

// Provider component
interface QuantifierProviderProps {
  children: ReactNode;
  initialButtonColor?: string;
  initialMobileButtonColor?: string;
  initialDarkModeButtonColor?: string;
}

export const QuantifierProvider: React.FC<QuantifierProviderProps> = ({
  children,
  initialButtonColor,
  initialMobileButtonColor,
  initialDarkModeButtonColor,
}) => {
  const [buttonBackgroundColor, setButtonBackgroundColor] =
    useState(initialButtonColor);
  const [mobileButtonBackgroundColor, setMobileButtonBackgroundColor] =
    useState(initialMobileButtonColor);
  const [darkModeButtonBackgroundColor, setDarkModeButtonBackgroundColor] =
    useState(initialDarkModeButtonColor);

  const resetColors = () => {
    setButtonBackgroundColor($champagne7);
    setMobileButtonBackgroundColor($beigeBg);
    setDarkModeButtonBackgroundColor("#494949");
  };

  const value = {
    buttonBackgroundColor,
    mobileButtonBackgroundColor,
    darkModeButtonBackgroundColor,
    setButtonBackgroundColor,
    setMobileButtonBackgroundColor,
    setDarkModeButtonBackgroundColor,
    resetColors,
  };

  return (
    <QuantifierContext.Provider value={value}>
      {children}
    </QuantifierContext.Provider>
  );
};

// Custom hook to use the quantifier context
export const useQuantifierContext = () => {
  const context = useContext(QuantifierContext);

  return (
    context || {
      setButtonBackgroundColor: () => {},
      setMobileButtonBackgroundColor: () => {},
      setDarkModeButtonBackgroundColor: () => {},
      resetColors: () => {},
    }
  );
};
